const ResourceHeader = {
  _selectors: {
    formStyle: '.js-resource-header-form-style',
    desktopTarget: '.resource-header__form',
    mobileTarget: '.resource-grid__form-mobile',
    mainTemplate: '.resource-main-template',
  },

  _debounceTimer: null,
  _resizeTimer: null,

  init() {
    const formStyle = document.querySelector(this._selectors.formStyle);
    const desktopTarget = document.querySelector(this._selectors.desktopTarget);
    const mobileTarget = document.querySelector(this._selectors.mobileTarget);
    const mainTemplate = document.querySelector(this._selectors.mainTemplate);

    if (!formStyle || !desktopTarget || !mobileTarget || !mainTemplate) return;

    this._formStyle = formStyle;
    this._desktopTarget = desktopTarget;
    this._mobileTarget = mobileTarget;
    this._mainTemplate = mainTemplate;

    this._placeForm();

    const resizeObserver = new ResizeObserver(() => {
      clearTimeout(this._debounceTimer);
      this._debounceTimer = setTimeout(() => this._syncMinHeight(), 150);
    });

    resizeObserver.observe(formStyle);

    window.addEventListener('resize', () => {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this._placeForm(), 150);
    });
  },

  /**
   * Moves the single form instance between the desktop header and the mobile
   * mount point depending on viewport width, avoiding a duplicate in the DOM.
   */
  _placeForm() {
    const isMobile = window.matchMedia('(max-width: 1023px)').matches;
    const target = isMobile ? this._mobileTarget : this._desktopTarget;

    // Don't move the form if it's already in the right container
    if (target.contains(this._formStyle)) return;

    target.appendChild(this._formStyle);
  },

  /**
   * Sets min-height on the main template wrapper to match the form's rendered
   * height, ensuring the form is always fully visible.
   */
  _syncMinHeight() {
    this._mainTemplate.style.minHeight = '';
    this._mainTemplate.style.minHeight = (this._formStyle.offsetHeight + 200) + 'px';
  },
};

export default ResourceHeader;
